/* eslint-disable @typescript-eslint/ban-types */
import { numberToHex, keccak256 } from 'web3-utils';
import { Encoding, Method } from '../types/Method';
export const METHODS = {
    [Method.GET_DATA]: {
        sig: '0x54f6127f',
        gas: numberToHex(2000000),
        gasPrice: numberToHex(100000000),
        value: numberToHex(0),
        returnEncoding: Encoding.BYTES,
    },
    [Method.DATA_COUNT]: {
        sig: '0x5da40c47',
        gas: numberToHex(2000000),
        gasPrice: numberToHex(100000000),
        value: numberToHex(0),
        returnEncoding: Encoding.UINT256,
    },
    [Method.ALL_DATA]: {
        sig: '0xc559acef',
        gas: numberToHex(2000000),
        gasPrice: numberToHex(100000000),
        value: numberToHex(0),
        returnEncoding: Encoding.BYTES32_ARRAY,
    },
    [Method.OWNER]: {
        sig: '0x8da5cb5b',
        gas: numberToHex(2000000),
        gasPrice: numberToHex(100000000),
        value: numberToHex(0),
        returnEncoding: Encoding.ADDRESS,
    },
};
export var SUPPORTED_HASH_FUNCTION_STRINGS;
(function (SUPPORTED_HASH_FUNCTION_STRINGS) {
    SUPPORTED_HASH_FUNCTION_STRINGS["KECCAK256_UTF8"] = "keccak256(utf8)";
    SUPPORTED_HASH_FUNCTION_STRINGS["KECCAK256_BYTES"] = "keccak256(bytes)";
})(SUPPORTED_HASH_FUNCTION_STRINGS || (SUPPORTED_HASH_FUNCTION_STRINGS = {}));
export var SUPPORTED_HASH_FUNCTION_HASHES;
(function (SUPPORTED_HASH_FUNCTION_HASHES) {
    SUPPORTED_HASH_FUNCTION_HASHES["HASH_KECCAK256_UTF8"] = "0x6f357c6a";
    SUPPORTED_HASH_FUNCTION_HASHES["HASH_KECCAK256_BYTES"] = "0x8019f9b1";
})(SUPPORTED_HASH_FUNCTION_HASHES || (SUPPORTED_HASH_FUNCTION_HASHES = {}));
export const SUPPORTED_HASH_FUNCTIONS_LIST = Object.values(SUPPORTED_HASH_FUNCTION_STRINGS);
function keccak256Utf8(data) {
    return keccak256(JSON.stringify(data));
}
const KECCAK256_UTF8 = {
    method: keccak256Utf8,
    name: SUPPORTED_HASH_FUNCTION_STRINGS.KECCAK256_UTF8,
    sig: SUPPORTED_HASH_FUNCTION_HASHES.HASH_KECCAK256_UTF8,
};
const KECCAK256_BYTES = {
    method: keccak256,
    name: SUPPORTED_HASH_FUNCTION_STRINGS.KECCAK256_BYTES,
    sig: SUPPORTED_HASH_FUNCTION_HASHES.HASH_KECCAK256_BYTES,
};
export const HASH_FUNCTIONS = {
    [SUPPORTED_HASH_FUNCTION_STRINGS.KECCAK256_UTF8]: KECCAK256_UTF8,
    [SUPPORTED_HASH_FUNCTION_HASHES.HASH_KECCAK256_UTF8]: KECCAK256_UTF8,
    [SUPPORTED_HASH_FUNCTION_STRINGS.KECCAK256_BYTES]: KECCAK256_BYTES,
    [SUPPORTED_HASH_FUNCTION_HASHES.HASH_KECCAK256_BYTES]: KECCAK256_BYTES,
};
//# sourceMappingURL=data:application/json;base64,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